import {
	permissionList,
	uwMerchantInfoPermissionSet,
	uwFinancialPermissionSet,
	attachmentPermissionSet,
	hasPermissions,
} from "helpers";

export const underwritingTabs = [
	{
		to: "merchant-info",
		eventKey: "merchant-info",
		label: "Merchant Information",
		requiredPermissions: uwMerchantInfoPermissionSet,
	},

	{
		to: "auto-checklist",
		eventKey: "auto-checklist",
		label: "Auto U/ W Result Checklist",
	},
	{
		to: "financials",
		eventKey: "financials",
		label: "Financials",
		requiredPermissions: uwFinancialPermissionSet,
	},
	{
		to: "attachments",
		eventKey: "attachments",
		label: "Attachments",
		requiredPermissions: attachmentPermissionSet,
	},
	{
		to: "deal-notes",
		eventKey: "deal-notes",
		label: "Deal Notes",
		requiredPermissions: permissionList.ViewAccountNotes,
	},
	{
		to: "pend-details",
		eventKey: "pend-details",
		label: "Pend Details",
	},
	{
		to: "residuals",
		eventKey: "residuals",
		label: "Residuals",
	},
];

export const getUnderwritingPaths = () =>
	underwritingTabs
		.filter(tab => hasPermissions(tab.requiredPermissions))
		.map(tab => tab.to);
